import { render, staticRenderFns } from "./automaticDropdown-editor.vue?vue&type=template&id=46679d4a&scoped=true"
import script from "./automaticDropdown-editor.vue?vue&type=script&lang=js"
export * from "./automaticDropdown-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46679d4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46679d4a')) {
      api.createRecord('46679d4a', component.options)
    } else {
      api.reload('46679d4a', component.options)
    }
    module.hot.accept("./automaticDropdown-editor.vue?vue&type=template&id=46679d4a&scoped=true", function () {
      api.rerender('46679d4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/automaticDropdown-editor.vue"
export default component.exports